import { render, staticRenderFns } from "./TemplateModalCard.vue?vue&type=template&id=2f2e1c3c"
import script from "./TemplateModalCard.vue?vue&type=script&lang=js"
export * from "./TemplateModalCard.vue?vue&type=script&lang=js"
import style0 from "./TemplateModalCard.vue?vue&type=style&index=0&id=2f2e1c3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports